import { useCallback, useContext } from "react";
import { LedgersResponse } from "../../interfaces/UserData";
import { LedgerResultContext } from "./ledger-context";



export const useLedgerResult = () => {
  const { ledgerResult, setLedgerResult } = useContext(LedgerResultContext);

  const createLedgerResult = useCallback(
    (newLedger: LedgersResponse | undefined): void => {
      setLedgerResult(newLedger);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ledgerResult]
  );

  const deleteLedgerResult = useCallback((): void => {
    setLedgerResult(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ledgerResult]);

  return {
    ledgerResult,
    createLedgerResult,
    deleteLedgerResult,
  };
};
